import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';
import { SnackbarAlert, SnackbarAlertStatus } from '../utils';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(private _snackBar: MatSnackBar) {}

  show(
    message: string,
    panelClass: string[] = SnackbarAlertStatus.SUCCESS,
    duration: number = 3000,
    action: string = ''
  ): MatSnackBarRef<any> {
    const config: MatSnackBarConfig = {
      duration,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass,
    };

    return this._snackBar.open(message, action, config);
  }
}
